export default __webpack_public_path__ + "static/media/BG_beldi.53e9f4cb.jpg";